<template>
    <div class="bg-white overflow-hidden shadow rounded-lg">
        <div class="p-5">
            <div class="flex items-center">
                <component :is="icon" class="h-6 w-6 text-gray-400"
                           aria-hidden="true"/>
                <div class="ml-5 w-0 flex-1">
                    <dl>
                        <dt class="text-sm font-medium text-gray-500 truncate">
                            {{ title}}
                        </dt>
                        <dd>
                            <div class="text-lg font-medium text-gray-900">
                                {{ value}}
                            </div>
                        </dd>
                    </dl>
                </div>
            </div>
        </div>
        <div class="bg-gray-50 px-5 py-3">
            <div class="text-sm">
                <a href="#" class="font-medium text-cyan-700 hover:text-cyan-900">
                    Details
                </a>
            </div>
        </div>
    </div>

</template>

<script>
export default {
    name: "Tile",
    props: ['icon', 'title', 'value']
}
</script>

<style scoped>

</style>
